function randomInteger(min, max) {
    return Math.floor(Math.random() * (max - min + 1)) + min;
}

function randomString(arr) {
    let idx = Math.floor(Math.random() * arr.length);
    return arr[idx];
}

function shuffleArray(arr) {
    for (let i = arr.length - 1; i > 0; i--) {
        const j = Math.floor(Math.random() * (i + 1));
        [arr[i], arr[j]] = [arr[j], arr[i]];
    }
}

function arraysAreEqual(arrayA, arrayB) {
    if (!Array.isArray(arrayA) || !Array.isArray(arrayB)) {
        return false;
    } else if (arrayA === arrayB) {
        return true;
    } else if (arrayA.length !== arrayB.length) {
        return false;
    } else {
        for (let x = 0; x < arrayA.length; ++x) {
            if (arrayA[x] !== arrayB[x]) return false;
        }
        return true;
    }
}

module.exports = {
    randomInteger,
    randomString,
    shuffleArray,
    arraysAreEqual
};